var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('env-label'),_vm._v(" "),_c('main-header'),_vm._v(" "),(_vm.$page.props.app.theme == 'dentagen')?_c('info-bar'):_vm._e(),_vm._v(" "),_c('main',{staticClass:"main"},[_c('messages'),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('main-footer'),_vm._v(" "),_c('modal'),_vm._v(" "),_c('support')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }